import React from "react";
import { Nav } from "../../../../layouts/navbar/nav";
import images from "../../../../constant/images";
import {
  PiFacebookLogoLight,
  PiGoogleLogo,
  PiTwitterLogo,
} from "react-icons/pi";
import Header from "../../../../layouts/header";
import { NavLink } from "react-router-dom"; // Add this import

export const Blog = () => {
  return (
    <>
      <div className="flex flex-col gap-[2rem]  mb-[5rem]">
        {/* <div
          className=" flex flex-col mb-14 "
          style={{
            backgroundImage: `url(${images.Industry})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            height: "60vh",
            backgroundRepeat: "no-repeat",
            position: "relative",
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-25"></div>
          <div className=" relative">
            <Nav />
          </div>
          <div className="h-[50%] flex items-center justify-center">
            <h1 className="text-center relative text-white text-6xl mt-[3.5rem] custom-font ">
              GTM GOLF BLOG
            </h1>
          </div>
          <svg
            className="absolute bottom-[-9%] left-0 "
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
          >
            <path
              class="white"
              fill="#fff"
              fill-opacity="1"
              d="M0,224L60,213.3C120,203,240,181,360,186.7C480,192,600,224,720,245.3C840,267,960,277,1080,250.7C1200,224,1300,170,1380,140L1440,120L1440,320L1380,320C1300,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            ></path>
          </svg>
        </div> */}
        <Header image={images.Industry} title={"GTM GOLF BLOG"}/>

      </div>

      <div className="flex flex-col lg:flex-row gap-9 relative">
  <div className="lg:ps-[10rem] ps-4 flex flex-col gap-[6rem] mb-[10rem]">
    <div className="flex gap-3">
      <div className="flex flex-col gap-2">
        <p className="flex flex-col ps-[13px] pe-[13px] pt-[5px] pb-[5px] items-center bg-[#45ac4d] text-white font-bold text-[20px]">
          28 <span className="text-[14px] font-[500]">Nov</span>
        </p>
        <div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#4c67a2] border-2">
            <PiFacebookLogoLight />
          </div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#00acee] border-2">
            <PiTwitterLogo />
          </div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#d77066] border-2">
            <PiGoogleLogo />
          </div>
        </div>
      </div>

      <div className="w-full lg:w-[50vw] flex flex-col gap-[2rem]">
        <img src={images.media1} alt="" />
        <NavLink
          to="/how-much-growth-potential-is-in-morocco-as-a-golf-destination"
          className="text-4xl custom-font hover:text-[#45ac4d]"
        >
          HOW MUCH GROWTH POTENTIAL IS IN MOROCCO AS A GOLF DESTINATION?
        </NavLink>
        <p className="text-[#8a8989] text-[16px] font-semibold">
          I’ve attended a few IGTM events and heard much about Morocco as a golf destination. It’s piqued my interest!...
        </p>
        <NavLink to="" className="text-[#45ac4d] text-[20px]">
          Read More
        </NavLink>
      </div>
    </div>

    <div className="flex gap-3">
      <div className="flex flex-col gap-2">
        <p className="flex flex-col ps-[13px] pe-[13px] pt-[5px] pb-[5px] items-center bg-[#45ac4d] text-white font-bold text-[20px]">
          16 <span className="text-[14px] font-[500]">Sep</span>
        </p>
        <div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#4c67a2] border-2">
            <PiFacebookLogoLight />
          </div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#00acee] border-2">
            <PiTwitterLogo />
          </div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#d77066] border-2">
            <PiGoogleLogo />
          </div>
        </div>
      </div>

      <div className="w-full lg:w-[50vw] flex flex-col gap-[3rem]">
        <NavLink
          to="/golf-frmg-and-cpg-sign-an-agreement-to-support-the-expansion-of-the-golfsixes-leagues-championship-in-morocco"
          className="text-4xl custom-font hover:text-[#45ac4d]"
        >
          Golf: FRMG and CPG sign an agreement to support the expansion of the «GolfSixes Leagues» championship in Morocco
        </NavLink>
        <p className="text-[#8a8989] text-[16px] font-semibold">
          The Royal Moroccan Golf Federation (FRMG), chaired by SAR Le Prince Moulay Rachid, and the «Confederation of Professional Golf»...
        </p>
        <NavLink to="" className="text-[#45ac4d] text-[20px]">
          Read More
        </NavLink>
      </div>
    </div>

    <div className="flex gap-3">
      <div className="flex flex-col gap-2">
        <p className="flex flex-col ps-[13px] pe-[13px] pt-[5px] pb-[5px] items-center bg-[#45ac4d] text-white font-bold text-[20px]">
          16 <span className="text-[14px] font-[500]">Sep</span>
        </p>
        <div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#4c67a2] border-2">
            <PiFacebookLogoLight />
          </div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#00acee] border-2">
            <PiTwitterLogo />
          </div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#d77066] border-2">
            <PiGoogleLogo />
          </div>
        </div>
      </div>

      <div className="w-full lg:w-[50vw] flex flex-col gap-[3rem]">
        <NavLink
          to="/golf-discovering-the-fantastic-offer-of-morocco"
          className="text-4xl custom-font hover:text-[#45ac4d]"
        >
          Golf: discovering the fantastic offer of Morocco
        </NavLink>
        <p className="text-[#8a8989] text-[16px] font-semibold">
          The housewarming of the Morocco Golf Cup takes place this Friday at the Zoute. This amateur competition reserved for...
        </p>
        <NavLink to="" className="text-[#45ac4d] text-[20px]">
          Read More
        </NavLink>
      </div>
    </div>

    <div className="flex gap-3">
      <div className="flex flex-col gap-2">
        <p className="flex flex-col ps-[13px] pe-[13px] pt-[5px] pb-[5px] items-center bg-[#45ac4d] text-white font-bold text-[20px]">
          16 <span className="text-[14px] font-[500]">Sep</span>
        </p>
        <div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#4c67a2] border-2">
            <PiFacebookLogoLight />
          </div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#00acee] border-2">
            <PiTwitterLogo />
          </div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#d77066] border-2">
            <PiGoogleLogo />
          </div>
        </div>
      </div>

      <div className="w-full lg:w-[50vw] flex flex-col gap-[3rem]">
        <NavLink
          to="/morocco-to-host-watc-in-2027"
          className="text-4xl custom-font hover:text-[#45ac4d]"
        >
          Morocco to host WATC in 2027
        </NavLink>
        <p className="text-[#8a8989] text-[16px] font-semibold">
          Rabat, Wednesday, August 31, 2022 – Under the presidency of His Royal Highness Prince Moulay Rachid, the Royal Moroccan...
        </p>
        <NavLink to="" className="text-[#45ac4d] text-[20px]">
          Read More
        </NavLink>
      </div>
    </div>

    <div className="flex gap-3">
      <div className="flex flex-col gap-2">
        <p className="flex flex-col ps-[13px] pe-[13px] pt-[5px] pb-[5px] items-center bg-[#45ac4d] text-white font-bold text-[20px]">
          16 <span className="text-[14px] font-[500]">Sep</span>
        </p>
        <div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#4c67a2] border-2">
            <PiFacebookLogoLight />
          </div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#00acee] border-2">
            <PiTwitterLogo />
          </div>
          <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#d77066] border-2">
            <PiGoogleLogo />
          </div>
        </div>
      </div>

      <div className="w-full lg:w-[50vw] flex flex-col gap-[3rem]">
        <NavLink
          to="/the-vision-of-development-of-golf-in-morocco/"
          className="text-4xl custom-font hover:text-[#45ac4d]"
        >
          The vision of development of golf in Morocco
        </NavLink>
        <p className="text-[#8a8989] text-[16px] font-semibold">
          The vision of development of golf in Morocco, launched in 2019 under the aegis of His Royal Highness Prince...
        </p>
        <NavLink to="" className="text-[#45ac4d] text-[20px]">
          Read More
        </NavLink>
      </div>
    </div>
  </div>

  <div className="flex flex-col gap-[1rem] w-full lg:w-[20vw] sticky top-10 self-start">
    <h1 className="text-2xl custom-font font-bold">Recent Posts</h1>
    <div className="flex flex-col gap-4">
      <h1 className="custom-font text-[17px]">
        The vision of development of golf in Morocco
      </h1>
      <p>16 Sep 2023</p>
    </div>
    <div className="flex flex-col gap-4">
      <h1 className="custom-font text-[17px]">
        Morocco to host WATC in 2027
      </h1>
      <p>16 Sep 2023</p>
    </div>
    <div className="flex flex-col gap-4">
      <h1 className="custom-font text-[17px]">
        Golf: discovering the fantastic offer of Morocco
      </h1>
      <p>16 Sep 2023</p>
    </div>
  </div>
</div>

    </>
  );
};
